"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("./services");
var close_reason_model_1 = require("./models/close-reason.model");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var AppComponent = /** @class */ (function () {
    function AppComponent(optionsService, visitService, invitationService, notificationService, loggingService, actionService) {
        var _this = this;
        this.optionsService = optionsService;
        this.visitService = visitService;
        this.invitationService = invitationService;
        this.notificationService = notificationService;
        this.loggingService = loggingService;
        this.actionService = actionService;
        this.invitationResourceStrings = {};
        this.CloseReason = close_reason_model_1.CloseReason;
        this.faTimes = free_solid_svg_icons_1.faTimes;
        this.notificationService.location$.subscribe(function (context) { return _this.onLocationChanged(context); });
        this.optionsService.options$.subscribe(function (options) { return _this.onOptionsChanged(options); });
        this.proactiveErrorSubscription = this.notificationService.proactiveChatError$.subscribe(function (errorMessage) {
            _this.error = errorMessage;
            //Disable logging for error view
            _this.loggingService.disableLogging = true;
            _this.invitationService.showProactivErrorView();
        });
    }
    AppComponent.prototype.ngOnInit = function () {
        console.info('Init: [ProactiveChat] Initializing.');
        // Ask the snippet's script to provide us with the initial url of the customer's page.
        // this.notificationService.requestLocation();
    };
    AppComponent.prototype.onLocationChanged = function (context) {
        console.log("Init: [ProactiveChat] location has been changed to " + context.location.href);
        this.error = null;
        // Cancel all action as we can have a different skill for the new location.
        this.actionService.cancelAll();
        // Log the visit.
        this.visitService.logVisit(context.location.href);
        // Update logging information for reporting
        this.loggingService.updateChatContext(context);
        // Update chat context to option services
        this.optionsService.updateChatContext(context);
    };
    AppComponent.prototype.onOptionsChanged = function (options) {
        console.log("Init: [ProactiveChat] fetched options for " + options.Location + " location");
        // init actions
        this.actionService.init(options);
        this.notificationService.sendApplicationStarted(options.SessionId);
        this.invitationResourceStrings = options.Invitation;
        this.actionService.start();
    };
    AppComponent.prototype.hideInvitation = function (reason) {
        this.invitationService.hideInvitation(reason);
        this.actionService.cancelCloseInvitation();
        this.error = null;
        this.loggingService.disableLogging = false;
    };
    AppComponent.prototype.acceptInvitation = function () {
        this.invitationService.acceptInvitation();
        this.actionService.cancelCloseInvitation();
    };
    AppComponent.prototype.ngOnDestroy = function () {
        this.proactiveErrorSubscription.unsubscribe();
        this.actionService.cancelAll();
    };
    return AppComponent;
}());
exports.AppComponent = AppComponent;
